import { customerService, transactionService } from "../../services";
import { custom, failure, success } from "./actionsUtilities";
import {
  storeActions,
  systemActions,
  customerActions,
  inventoryActions,
  outletActions,
} from "../actions";
import {
  toastType,
  toastMessages,
  systemConstants,
  globalConstants,
  routesPathConstants,
  transactionConstants,
  transactionDefaultData,
  tradeTransactionDefaultData,
  inventoryConstants,
  SALE_TRANSACTION_ACTIVITY_TYPES,
  outletConstants,
  toggleSwitchButtonConstants,
  EMPTY_STRING,
} from "../../constants";
import {
  customToast,
  parseToNumber,
  parseToDecimalNumber,
  getSumOfPaymentHistory,
  updateCartLocalStorage,
  convertToFixedPrecision,
  getCountOfTradeTotalItems,
  parseToThousandSeperatorDecimalNumber,
  calculateTransactionTaxPercentage,
  handleIsLabelNotificationOnEditInventory,
  getUpdatedOfferValues,
  getSplitPaymentOfferValues,
  getLockCustomerPayload,
  getOutletRelationObjectForSaleTradePayload,
  getSessionIdForSaleTradePayload,
} from "../../shared/utility";
import { EMAIL_MESSAGE_TYPES } from "../../system/globalEnums";

//-------Get all Transaction
const getAllTransaction = (storeId, type, start, end, gridState, companyId) => {
  return (dispatch) => {
    dispatch(
      custom(
        transactionConstants.GET_ALL_TRANSACTION,
        systemConstants.SPINNER_ACTIVATE
      )
    );
    transactionService
      .getAllTransaction(storeId, type, start, end, gridState, companyId)
      .then(
        (response) => {
          dispatch(success(response, transactionConstants.GET_ALL_TRANSACTION));
        },
        (error) => {
          dispatch(failure([], transactionConstants.GET_ALL_TRANSACTION));
          customToast(error, toastType.ERROR);
        }
      )
      .finally(() => {
        dispatch(
          custom(
            transactionConstants.GET_ALL_TRANSACTION,
            systemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

//-------Get all draft
const getAllDraft = (storeId, type, start, end, cat) => {
  return (dispatch) => {
    dispatch(
      custom(
        transactionConstants.GET_ALL_DRAFT,
        systemConstants.SPINNER_ACTIVATE
      )
    );
    transactionService
      .getAllDraft(storeId, type, start, end, cat)
      .then(
        (response) => {
          dispatch(success(response, transactionConstants.GET_ALL_DRAFT));
        },
        (error) => {
          customToast(error, toastType.ERROR);
        }
      )
      .finally(() => {
        dispatch(
          custom(
            transactionConstants.GET_ALL_DRAFT,
            systemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

//-------Get search Transaction
const getSearchTransaction = (storeId, id) => {
  return (dispatch) => {
    dispatch(
      custom(
        transactionConstants.GET_SEARCH_TRANSACTION,
        systemConstants.SPINNER_ACTIVATE
      )
    );
    transactionService
      .getSearchTransaction(storeId, id)
      .then(
        (response) => {
          response[0] = {
            ...response[0],
            taxPercentage: response[0].hasOwnProperty("taxPercentage")
              ? response[0].taxPercentage
              : calculateTransactionTaxPercentage(response[0]),
          };
          dispatch(
            success(response, transactionConstants.GET_SEARCH_TRANSACTION)
          );
        },
        (error) => {
          dispatch(failure([], transactionConstants.GET_SEARCH_TRANSACTION));
          customToast(error, toastType.ERROR);
        }
      )
      .finally(() => {
        dispatch(
          custom(
            transactionConstants.GET_SEARCH_TRANSACTION,
            systemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

//-------emptySearchTransaction
const emptySearchTransaction = () => {
  return (dispatch) => {
    dispatch(success([], transactionConstants.GET_SEARCH_TRANSACTION));
  };
};

//-------addReturn
const addReturn = (returnData, companyId, storeId) => {
  return (dispatch) => {
    dispatch(
      custom(transactionConstants.ADD_RETURN, systemConstants.SPINNER_ACTIVATE)
    );
    transactionService
      .addReturn(returnData, storeId)
      .then(
        (response) => {
          dispatch(customerActions.getPaginationCustomers(companyId, storeId));
          dispatch(
            systemActions.pageRedireaction(
              routesPathConstants.INVENTORY_ITEMS_HISTORY
            )
          );
          returnData.macAddress &&
            dispatch(
              outletActions.getOutletByMacAddress(
                returnData?.store?.id,
                returnData.macAddress
              )
            );
          dispatch(success([], transactionConstants.GET_SEARCH_TRANSACTION));
          if (
            handleIsLabelNotificationOnEditInventory(
              { data: { data: response } },
              true
            )
          ) {
            dispatch(
              storeActions.getUserNotifications(
                storeId,
                true,
                toastMessages.RETURN_HAS_BEEN_SUCCESSFULL,
                true
              )
            );
          } else {
            customToast(
              toastMessages.RETURN_HAS_BEEN_SUCCESSFULL,
              toastType.SUCCESS
            );
          }
        },
        (error) => {
          customToast(error, toastType.ERROR);
        }
      )
      .finally(() => {
        dispatch(
          custom(
            transactionConstants.ADD_RETURN,
            systemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

//-------getReturnId
const getReturnId = () => {
  return (dispatch) => {
    dispatch(
      custom(
        transactionConstants.GET_RETURN_ID,
        systemConstants.SPINNER_ACTIVATE
      )
    );
    transactionService
      .getReturnId()
      .then(
        (response) => {
          dispatch(success(response, transactionConstants.GET_RETURN_ID));
        },
        (error) => {
          dispatch(failure([], transactionConstants.GET_RETURN_ID));
          customToast(error, toastType.ERROR);
        }
      )
      .finally(() => {
        dispatch(
          custom(
            transactionConstants.GET_RETURN_ID,
            systemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

//-------Get all draft
const getGiftCardDetails = (storeId, barcode) => {
  return (dispatch) => {
    dispatch(
      custom(
        transactionConstants.GET_GIFT_CARD_DETAILS,
        systemConstants.SPINNER_ACTIVATE
      )
    );
    dispatch(
      success({ isLoading: true }, transactionConstants.GET_GIFT_CARD_DETAILS)
    );
    transactionService
      .getGiftCardDetails(storeId, barcode)
      .then(
        (response) => {
          dispatch(
            success(response, transactionConstants.GET_GIFT_CARD_DETAILS)
          );
        },
        (error) => {
          dispatch(
            success(EMPTY_STRING, transactionConstants.GET_GIFT_CARD_DETAILS)
          );
          customToast(error, toastType.ERROR);
        }
      )
      .finally(() => {
        dispatch(
          custom(
            transactionConstants.GET_GIFT_CARD_DETAILS,
            systemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

const emptyGiftCardDetails = () => {
  return (dispatch) => {
    dispatch(success(EMPTY_STRING, transactionConstants.GET_GIFT_CARD_DETAILS));
  };
};

const setTransactionData = (transactionData, storeId) => {
  return (dispatch) => {
    if (storeId) {
      updateCartLocalStorage(
        transactionConstants.NEW_SALE_PAGE_DATA,
        transactionData,
        storeId
      );

      dispatch(
        custom(transactionData, transactionConstants.SET_TRANSACTION_DATA)
      );
    }
  };
};

const setNewTradeData = (tardeData, storeId) => {
  return (dispatch) => {
    if (storeId) {
      updateCartLocalStorage(
        transactionConstants.NEW_TRADE_PAGE_DATA,
        tardeData,
        storeId
      );

      dispatch(custom(tardeData, transactionConstants.SET_NEW_TRADE_DATA));
    }
  };
};

const setAddTradeBatchInventory = (tardeBatchData, storeId) => {
  return (dispatch) => {
    if (storeId) {
      updateCartLocalStorage(
        transactionConstants.TRADE_BATCH_DATA,
        tardeBatchData,
        storeId
      );
      dispatch(
        success(
          tardeBatchData,
          transactionConstants.SET_ADD_TRADE_BATCH_INVENTORY
        )
      );
    }
  };
};

//-------Page Redireaction
const toggleAddCustomerModal = (value) => {
  return (dispatch) => {
    dispatch(custom(value, transactionConstants.TOGGLE_ADD_CUSTOMER_MODAL));
  };
};

//-------Get all draft
const newSaleTransaction = (
  data,
  transactionObject,
  handlePaymentMethod,
  handlePrintReceipt,
  isAutoPrint,
  isUndoTransaction = false,
  message,
  handleOpenCashDrawer,
  defaultReceiptPrinter,
  updateTransactionData
) => {
  return (dispatch) => {
    dispatch(
      custom(
        transactionConstants.MAKE_TRANSACTION,
        systemConstants.SPINNER_ACTIVATE
      )
    );

    transactionService
      .newSaleTransaction(
        {
          ...data,
        },
        isUndoTransaction
      )
      .then(
        (response) => {
          const updatedTransactionData = {
            ...transactionObject,
            ...response,
            store: transactionObject.store,
            paymentMethod:
              data.TransactionType === transactionConstants.DRAFT
                ? EMPTY_STRING
                : transactionConstants.PAYMENT_COMPLETE,
            currentAmountToPay: Number(
              response.totalAmountToPay -
                getSumOfPaymentHistory(response.paymentHistory)
            ).toFixed(2),
            poiId: EMPTY_STRING,
            giftCard: globalConstants.EMPTY_OBJECT,
            paymentDevice: EMPTY_STRING,
            inventory: [...response.inventory],
            createdOn: response.createdOn,
          };

          if (
            (data?.PaymentType === transactionConstants.CASH &&
              updatedTransactionData?.paymentMethod !==
                transactionConstants.PAYMENT_COMPLETE) ||
            (data?.PaymentType === transactionConstants.CASH &&
              updatedTransactionData?.paymentMethod ===
                transactionConstants.PAYMENT_COMPLETE &&
              !isAutoPrint)
          ) {
            handleOpenCashDrawer(defaultReceiptPrinter);
          }
          // if transaction is completed (Processed)
          if (
            updatedTransactionData?.paymentMethod ===
            transactionConstants.PAYMENT_COMPLETE
          ) {
            isAutoPrint &&
              handlePrintReceipt(
                updatedTransactionData,
                data?.PaymentType === transactionConstants.CASH
              );
            data.macAddress &&
              dispatch(
                outletActions.getOutletByMacAddress(
                  updatedTransactionData?.store?.id,
                  data.macAddress
                )
              );
          }

          updateTransactionData(
            updatedTransactionData,
            SALE_TRANSACTION_ACTIVITY_TYPES.AFTER_SUCCESSFULL_TRANSACTION
          );

          dispatch(emptyGiftCardDetails());
          customToast(message, toastType.SUCCESS);
          if (data.PaymentType === transactionConstants.STORE_CREDIT) {
            dispatch(
              customerActions.getCustomerById(
                data.companyId,
                data.store.id,
                updatedTransactionData.customer.id
              )
            );
          }
        },
        (error) => {
          handlePaymentMethod(EMPTY_STRING);
          customToast(error, toastType.ERROR);
        }
      )
      .finally(() => {
        dispatch(
          custom(
            transactionConstants.MAKE_TRANSACTION,
            systemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

const handleNewParkSale = (
  transactionData,
  currentStore,
  outlet,
  callBack = () => {}
) => {
  return async (dispatch) => {
    if (transactionData.inventory?.length > 0) {
      dispatch(
        custom(
          transactionConstants.MAKE_TRANSACTION,
          systemConstants.SPINNER_ACTIVATE
        )
      );
      const transactionId =
        transactionData?.id || (await transactionActions.getTransactionId());
      dispatch(
        custom(
          transactionConstants.MAKE_TRANSACTION,
          systemConstants.SPINNER_DEACTIVATE
        )
      );
      transactionData.id = transactionId;
      callBack();
      const dataToSend = {
        id: transactionData.id,
        Tax: transactionData?.tax,
        note: transactionData.note,
        discount: transactionData.discount,
        SubTotal: transactionData?.subTotal,
        poiId: EMPTY_STRING,
        inventory: transactionData.inventory,
        creditCard: transactionData.creditCard,
        giftCard: globalConstants.EMPTY_OBJECT,
        creditUsed: transactionData.creditUsed,
        isNoteField: transactionData.isNoteField,
        TransactionType: transactionConstants.DRAFT,
        PaymentType: transactionConstants.PARK_SALE,
        isTaxApplied: transactionData.isTaxApplied,
        cashChangeOwed: transactionData.cashChangeOwed,
        discountMethod: transactionData.discountMethod,
        paymentHistory: transactionData?.paymentHistory,
        isDiscountField: transactionData.isDiscountField,
        totalAmountToPay: transactionData?.totalAmountToPay,
        discountedValue: transactionData.discountedValue || 0,
        currentAmountToPay: transactionData.currentAmountToPay,
        cashTenderedAmount: transactionData.cashTenderedAmount,
        activeCardPaymentType: currentStore.activeCardPaymentType,
        giftCardPaymentHistory: transactionData.giftCardPaymentHistory,
        paymentTypeOrder: transactionData.paymentTypeOrder,
        initialTotalCogs: transactionData?.initialTotalCogs,
        initialTotalStockPrice: transactionData?.initialTotalStockPrice,
        store: {
          id: currentStore?.id,
          name: currentStore?.storeName,
        },
        customer: transactionData.customer
          ? transactionData.customer
          : { id: "", name: "" },
        outlet: getOutletRelationObjectForSaleTradePayload(
          currentStore,
          outlet?.currentOutlet
        ),
        sessionId: getSessionIdForSaleTradePayload(
          currentStore,
          outlet?.currentOutlet,
          outlet?.currentSessionId
        ),
        processedBy: transactionData.processedBy,
      };
      dispatch(parkSale(dataToSend));
    } else {
      customToast(toastMessages.PLEASE_SELECT_SOME_PRODUCT, toastType.ERROR);
    }
  };
};

//-------Bulk Upload Transaction History
const bulkUploadTransactionHistory = (storeId, data) => {
  return (dispatch) => {
    dispatch(
      custom(
        transactionConstants.BULK_UPLOAD_HISTORY,
        systemConstants.SPINNER_ACTIVATE
      )
    );
    transactionService
      .bulkUploadTransactionHistory(storeId, data)
      .then(
        (response) => {
          dispatch(
            success(
              response?.data?.data,
              transactionConstants.BULK_UPLOAD_HISTORY
            )
          );
          customToast(response?.data?.message, toastType.SUCCESS);
          dispatch(getAllTransaction(storeId));
        },
        (error) => {
          customToast(error, toastType.ERROR);
        }
      )
      .finally(() => {
        dispatch(
          custom(
            transactionConstants.BULK_UPLOAD_HISTORY,
            systemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

//-------Get all draft
const cancelCardTransaction = (data, transactionObject) => {
  return (dispatch) => {
    dispatch(
      custom(
        transactionConstants.CANCEL_TRANSACTION,
        systemConstants.SPINNER_ACTIVATE
      )
    );
    transactionService
      .cancelCardTransaction(data)
      .then(
        (response) => {
          customToast(
            toastMessages.TRANSACTION_CANCEL_SUCCESSFULLY,
            toastType.SUCCESS
          );
        },
        (error) => {
          customToast(error, toastType.ERROR);
        }
      )
      .finally(() => {
        if (transactionObject) {
          dispatch(
            setTransactionData(
              {
                ...transactionObject,
                poiId: EMPTY_STRING,
                paymentDevice: EMPTY_STRING,
                paymentMethod: EMPTY_STRING,
              },
              transactionObject.store.id
            )
          );
        }
        dispatch(
          custom(
            transactionConstants.CANCEL_TRANSACTION,
            systemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};
//------ function to calculate remaining amount in case of split payment
//------ either cash or trade
const calculation = (newTradeData, response) => {
  const paymentStatus =
    response.totalAmountToPay - getSumOfPaymentHistory(response.paymentHistory)
      ? EMPTY_STRING
      : transactionConstants.PAYMENT_COMPLETE;
  if (paymentStatus === EMPTY_STRING) {
    if (response.PaymentType === globalConstants.CASH) {
      const percentage =
        (response.currentAmountToPay * 100) / newTradeData.totalCashOffer;
      const tradePercentage = (newTradeData.totalTradeOffer * percentage) / 100;
      const tradeValue = newTradeData.totalTradeOffer - tradePercentage;
      return tradeValue;
    } else {
      const percentage =
        (response.currentAmountToPay * 100) / newTradeData.totalTradeOffer;
      const cashPercentage = (newTradeData.totalCashOffer * percentage) / 100;
      const cashValue = newTradeData.totalCashOffer - cashPercentage;
      return cashValue;
    }
  } else {
    return 0;
  }
};

const tradeTransaction = (
  data,
  companyId,
  newTradeData,
  updateTradeData,
  handlePrintReceipt,
  isAutoPrintReceipt,
  handleOpenCashDrawer,
  defaultReceiptPrinter
) => {
  //-------Get storeId from data
  const storeId = data.store.id;

  //-------Dispatch Action
  return (dispatch) => {
    //-------Activate Spinner
    dispatch(
      custom(
        transactionConstants.MAKE_TRADE_TRANSACTION,
        systemConstants.SPINNER_ACTIVATE
      )
    );
    //-------Trade Transaction Service
    transactionService
      .newTradeTransaction(data, storeId)
      .then(
        (response) => {
          const { TransactionType } = data;
          if (TransactionType === transactionConstants.DRAFT) {
            console.log("transaction type draft");
          } else if (TransactionType === transactionConstants.PROCESSED) {
            let updatedTradeData = {
              ...newTradeData,
              ...response,
              amountToPay: 0,
              poiId: EMPTY_STRING,
              store: newTradeData.store,
              customer: newTradeData.customer,
              giftCard: globalConstants.EMPTY_OBJECT,
              paymentMethod: transactionConstants.PAYMENT_COMPLETE,
            };

            //------- open cash drawer if payment type is cash or split

            if (isAutoPrintReceipt) {
              handlePrintReceipt(updatedTradeData);
            } else if (
              data?.PaymentType === transactionConstants.CASH ||
              data?.PaymentType === transactionConstants.SPLIT
            ) {
              handleOpenCashDrawer(defaultReceiptPrinter);
            }

            //-------get updated customer: e.g store credit here
            if (updatedTradeData.customer?.id) {
              dispatch(
                customerActions.getCustomerById(
                  companyId,
                  storeId,
                  updatedTradeData.customer.id
                )
              );
            }

            //-------Check if inventory is a valid array and all items have product_id equal to QUICK_TRADE
            const isAloneQuickTrade =
              //-------Check if inventory exists and is an array
              Array.isArray(newTradeData?.inventory) &&
              //-------Ensure every item in inventory has product_id equal to QUICK_TRADE
              newTradeData.inventory.every(
                (item) => item?.product_id === transactionConstants.QUICK_TRADE
              );

            //-------Genearte Printer Label Notification for products except quick trade
            dispatch(
              storeActions.getUserNotifications(
                storeId,
                true,
                `${
                  isAloneQuickTrade
                    ? newTradeData?.inventory[0]?.price?.totalItems
                    : getCountOfTradeTotalItems(
                        newTradeData.inventory || 0,
                        "quantity"
                      )
                } items added successfully.`,
                false,
                !isAloneQuickTrade
              )
            );

            //-------Update the current cart state with updated values
            updateTradeData(
              updatedTradeData,
              SALE_TRANSACTION_ACTIVITY_TYPES.AFTER_SUCCESSFULL_TRANSACTION
            );
          }
        },
        (error) => {
          customToast(error, toastType.ERROR);
        }
      )
      .finally(() => {
        dispatch(
          custom(
            transactionConstants.MAKE_TRADE_TRANSACTION,
            systemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

const handleUpdateCustomerInSessionHistory = (
  data,
  transactionDetails,
  endPoint = "transaction",
  sessionId
) => {
  return (dispatch) => {
    dispatch(
      custom(
        transactionConstants.UPDATE_HISTORY_CUSTOMER,
        systemConstants.SPINNER_ACTIVATE
      )
    );

    transactionService
      .updateCustomerInTransactionHistory(data, transactionDetails, endPoint)
      .then(
        (response) => {
          dispatch(
            outletActions.getSessionHistory(
              transactionDetails?.storeId,
              sessionId
            )
          );
        },
        (error) => {
          customToast(error, toastType.ERROR);
        }
      )
      .finally(() => {
        dispatch(
          custom(
            transactionConstants.UPDATE_HISTORY_CUSTOMER,
            systemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

const updateCustomerInTransactionHistory = (
  data,
  transactionDetails,
  gridState,
  endPoint = "transaction"
) => {
  return (dispatch) => {
    dispatch(
      custom(
        transactionConstants.UPDATE_HISTORY_CUSTOMER,
        systemConstants.SPINNER_ACTIVATE
      )
    );
    transactionService
      .updateCustomerInTransactionHistory(data, transactionDetails, endPoint)
      .then(
        (response) => {
          if (gridState) {
            dispatch(
              getAllTransaction(
                transactionDetails.storeId,
                transactionDetails.type,
                transactionDetails.start,
                transactionDetails.end,
                gridState,
                transactionDetails.companyId
              )
            );
          }
        },
        (error) => {
          customToast(error, toastType.ERROR);
        }
      )
      .finally(() => {
        dispatch(
          custom(
            transactionConstants.UPDATE_HISTORY_CUSTOMER,
            systemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

//-------Get park sale
const parkSale = (data) => {
  return (dispatch) => {
    dispatch(
      custom(
        transactionConstants.MAKE_TRANSACTION,
        systemConstants.SPINNER_ACTIVATE
      )
    );

    transactionService
      .newSaleTransaction(data)
      .then(
        (response) => {
          dispatch(setTransactionData(transactionDefaultData, data.store.id));
          dispatch(emptyGiftCardDetails());
          customToast(
            toastMessages.TRANSACTION_DRAFT_SUCCESSFULLY,
            toastType.SUCCESS
          );
        },
        (error) => {
          customToast(error, toastType.ERROR);
        }
      )
      .finally(() => {
        dispatch(
          custom(
            transactionConstants.MAKE_TRANSACTION,
            systemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

const getTradeId = () => {
  return transactionService.getTradeId().then(
    (response) => {
      if (response) {
        return response;
      }
    },
    (error) => {
      customToast(error, toastType.ERROR);
    }
  );
};

//-------newTradePark
const newTradePark = (data, storeId, callBack = () => {}) => {
  return (dispatch) => {
    dispatch(
      custom(
        transactionConstants.MAKE_TRADE_TRANSACTION,
        systemConstants.SPINNER_ACTIVATE
      )
    );
    transactionService
      .newTradePark(data, storeId)
      .then(
        (response) => {
          dispatch(setNewTradeData(tradeTransactionDefaultData, storeId));
          dispatch(success([], inventoryConstants.SET_ADD_BATCH_INVENTORY));
          customToast(toastMessages.PARK_TRADE_SUCCESSFULLY, toastType.SUCCESS);
          callBack();
        },
        (error) => {
          customToast(error, toastType.ERROR);
        }
      )
      .finally(() => {
        dispatch(
          custom(
            transactionConstants.MAKE_TRADE_TRANSACTION,
            systemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};
//-------get Sku Number
const getTransactionId = () => {
  return transactionService.getTransactionId().then(
    (response) => {
      if (response) {
        return response;
      }
    },
    (error) => {
      customToast(error, toastType.ERROR);
    }
  );
};

//-------Export Transaction Actions
const emptyDuplicateRecords = () => {
  return (dispatch) => {
    dispatch(success([], transactionConstants.BULK_UPLOAD_HISTORY));
  };
};

//-------addReturn
const sendEmailOrSMS = (data, messageType) => {
  return (dispatch) => {
    dispatch(
      custom(
        transactionConstants.SEND_EMAIL_OR_SMS,
        systemConstants.SPINNER_ACTIVATE
      )
    );
    transactionService
      .sendEmailOrSms(data)
      .then(
        (response) => {
          if (messageType === EMAIL_MESSAGE_TYPES.USER_REPORTED_ISSUE) {
            dispatch(
              systemActions.pageRedireaction(routesPathConstants.DEFAULT_PATH)
            );
            customToast(toastMessages.PROBLEM_MESSAGE_SENT, toastType.SUCCESS);
          } else {
            customToast(
              toastMessages.RECEIPT_SENT_SUCCESSFULLY,
              toastType.SUCCESS
            );
          }
        },
        (error) => {
          customToast(error, toastType.ERROR);
        }
      )
      .finally(() => {
        dispatch(
          custom(
            transactionConstants.SEND_EMAIL_OR_SMS,
            systemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};
// temp sku
const generateTempSku = (data) => {
  return (dispatch) => {
    dispatch(success(data, transactionConstants.TEMP_SKU));
  };
};
//-------Delete draft
const deleteDraft = (transactionId, storeDetail, toast) => {
  return (dispatch) => {
    dispatch(
      custom(
        transactionConstants.DELETED_DRAFT,
        systemConstants.SPINNER_ACTIVATE
      )
    );
    transactionService
      .deleteDraft(transactionId, storeDetail.storeId)
      .then(
        () => {
          toast &&
            customToast(
              toastMessages.DRAFT_DELETED_SUCCESSFULLY,
              toastType.SUCCESS
            );

          dispatch(
            getAllDraft(
              storeDetail.storeId,
              storeDetail.type,
              storeDetail.startDate,
              storeDetail.endDate
            )
          );
        },
        (error) => {
          customToast(error, toastType.ERROR);
        }
      )
      .finally(() => {
        dispatch(
          custom(
            transactionConstants.DELETED_DRAFT,
            systemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

//-------Export Authentication Actions
export const transactionActions = {
  parkSale,
  addReturn,
  getTradeId,
  getAllDraft,
  deleteDraft,
  getReturnId,
  newTradePark,
  sendEmailOrSMS,
  generateTempSku,
  setNewTradeData,
  getTransactionId,
  tradeTransaction,
  getAllTransaction,
  handleNewParkSale,
  setTransactionData,
  getGiftCardDetails,
  newSaleTransaction,
  emptyGiftCardDetails,
  getSearchTransaction,
  emptyDuplicateRecords,
  cancelCardTransaction,
  emptySearchTransaction,
  toggleAddCustomerModal,
  setAddTradeBatchInventory,
  bulkUploadTransactionHistory,
  updateCustomerInTransactionHistory,
  handleUpdateCustomerInSessionHistory,
};
